import { getAuth, signOut } from "firebase/auth";

// export const url = "http://localhost:3001";
// export const url = "https://shareme.loca.lt";
export const url = "https://shareme-backend.onrender.com";
export const getHeaders = async () => {
  const auth = await getAuth();
  if (!auth.currentUser) return;
  const access_token = await auth.currentUser.getIdToken();

  return {
    "Content-Type": "application/json",
    authorization: `${access_token}`,
  };
};
export const getMyPhoneNumber = async () => {
  const auth = await getAuth();
  if (!auth) return {};
  const phoneNumber = await auth.currentUser.phoneNumber;
  return phoneNumber;
};

export const logOut = async () => {
  const auth = await getAuth();
  await auth.signOut();
};
